module.exports = __webpack_public_path__ + "static/media/menu.7bcab58a.svg";